function like(compareValue) {
	return this.toLocaleLowerCase('tr').includes(compareValue.toLocaleLowerCase('tr'))
}
String.prototype.like = like
